import { Component, OnInit } from '@angular/core';
import { ApiService } from "../services/api.service";


@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {
  departmentsList = [];
  usersList = [];
  groupList = [];
  courseList = [];
  sessionList = [];
  facultyList = [];
  studentList = [];
  groupMemberList = [];
  eventTitle: any;
  Room: any;
  department: any;
  course: any;
  session: any;
  startDateTime: any;
  endDateTime: any;
  note: any;
  stuinfonew = [];
  userId: any;
  isSchedule: '1';
  group: any;
  randomIDs: any;
  randomPasswords: any;
  eventType: any;
  isShownMeetingDetails: boolean;
  isShownERPDetails: boolean;
  isShownSMSDetails: boolean;
  isShownGroupDetails: boolean;
  isShownModuleDetails: boolean;
  startDate: any;
  startTime: any;
  endDate: any;
  endTime: any;
  takenById:any;
  takenBy:any;
  dUser:any;
  isShownRecordedDetails:any;
  selectedFile:any;
  constructor(

    public ApiServiceCall: ApiService,

  ) {
    this.eventTitle;
    this.Room;
    this.startDateTime;
    this.endDateTime;
    this.note;
    // this.meetingAttendeeList,
    this.userId;
    this.isSchedule;
    this.randomIDs;
    this.randomPasswords;
    this.eventType;
    this.departmentsList;
    this.usersList;
    this.courseList;
    this.sessionList;
    this.facultyList;
    this.studentList;
    this.startDate;
    this.startTime;
    this.endDate;
    this.endTime;
    this.groupList;
    this.groupMemberList;
    this.department;
    this.course;
    this.group;
    this.session;
    this.isShownMeetingDetails = false;
    this.isShownERPDetails = false;
    this.isShownSMSDetails = false;
    this.isShownGroupDetails = false;
    this.isShownModuleDetails = false;
    this.takenById;
    this.takenBy;
    this.dUser;
    this.isShownRecordedDetails;
    this.selectedFile;
  }




  ngOnInit(): void {
    this.randomIDs = this.makeid(9);
    this.randomPasswords = this.makepassword(6);
    this.eventTitle = 'sandeep';
    this.getAllFacultyList();
    this.getAllCourseList();
    this.getAllSessionList();
    this.getAllDepartmentList();
    this.getAllGroupList();
    this.userId = localStorage.getItem('userID');
  }
  setTakebyID(value)
  {
    this.takenById = value;
    alert(this.takenById);
  }
  getAllDepartmentList() {
    var obj = {};
    this.ApiServiceCall.getdeptData(obj).subscribe((data) => {

      console.log(data['dept']);
      this.departmentsList = data['dept'];

    });


  }
  getAllUsersList() {
    var obj = { deptID: this.department };
    this.ApiServiceCall.getemployData(obj).subscribe((data) => {

      console.log(data['emp']);
      this.usersList = data['emp'];
      this.stuinfonew = [];
      for(let i=0; i<this.usersList.length; i++)
      {
        console.log(this.usersList[i]['empID']);
        this.stuinfonew.push({"webinarAttendee": this.usersList[i]['empID']});
        
      }
     console.log(''+JSON.stringify(this.stuinfonew));



    });


  }
  getAllCourseList() {
    var obj = { userId: '11' };
    this.ApiServiceCall.getcouData(obj).subscribe((data) => {

      console.log(data.responseValue.courseMaster);
      this.courseList = data.responseValue.courseMaster;

    });


  }

  getAllSessionList() {
    var obj = { userId: '11' };
    this.ApiServiceCall.getsesData(obj).subscribe((data) => {

      console.log(data.responseValue.sessionMaster);
      this.sessionList = data.responseValue.sessionMaster;

    });


  }
  getAllFacultyList() {
    var obj = { userId: '11' };
    this.ApiServiceCall.getfacData(obj).subscribe((data) => {

      console.log(data.responseValue.teacherMaster);
      this.facultyList = data.responseValue.teacherMaster;

    });


  }
  getAllStudentList() {

    console.log('sandeep' + this.course);
    console.log('sandeep' + this.session);
    var obj = { userId: '11', courseId: this.course, sessionId: this.session };
    this.ApiServiceCall.getstuData(obj).subscribe((data) => {

      console.log(data);
      this.studentList = data.responseValue.studentList;

      this.stuinfonew = [];
      for(let i=0; i<this.studentList.length; i++)
      {
        console.log(this.studentList[i]['id']);
        this.stuinfonew.push({"webinarAttendee": this.studentList[i]['id']});
        
      }
     console.log(''+JSON.stringify(this.stuinfonew));


    });


  }



  getAllGroupList() {

    var obj = { instituteId: localStorage.getItem('userID') };
    this.ApiServiceCall.getGroupList(obj).subscribe((data) => {

      console.log(data);
      this.groupList = data.responseValue;

    });


  }

  getAllGroupMemberList() {

    var obj = { groupId: this.group };
    this.ApiServiceCall.showGroupList(obj).subscribe((data) => {

      console.log(data);
      this.groupMemberList = data.responseValue;


      for(let i=0; i<this.groupMemberList.length; i++)
      {
        console.log(this.groupMemberList[i]['userId']);
        this.stuinfonew.push({"webinarAttendee": this.groupMemberList[i]['userId']});
        
      }
     console.log(''+JSON.stringify(this.stuinfonew));


    });
    
    
  }
  createMeeting() {

    var obj = {
      eventName: this.eventTitle,
      roomName: this.Room,
      startDateTime: this.startDateTime,
      endDateTime: this.endDateTime,
      note: this.note,
      meetingAttendeeList: JSON.stringify(this.stuinfonew),
      userId: this.userId,
      isSchedule: '1',
      meetingId: this.randomIDs,
      password: this.randomPasswords
    };
    console.log(obj);
    this.ApiServiceCall.createMeeting(obj).subscribe((data) => {


      if(data.responseCode == '1')
      {
        console.log(data.responseMessage);
        alert('success');
      }
      else
      {
        alert(data.responseMessage);
      }
  
      
    });

  }

  async createWebinar() {
var isLive;
var finalVideoPath = '';
if(this.isShownRecordedDetails == true)
{
  
  const fb = new FormData();
  fb.append('video', this.selectedFile);
  await this.ApiServiceCall.saveMultipleFile(fb).subscribe((data) => {
    console.log('responsefromfile'+data.responsedata);
   var filePath = JSON.parse(data.responsedata);
 
    finalVideoPath  = filePath[0].filePath;
    if(finalVideoPath != '')
    {
      var obj = {
        eventName : this.eventTitle,
        roomName: this.Room,
        startDateTime : this.startDateTime,
        endDateTime : this.endDateTime,
        note : '',
        takenBy : this.takenById,
        webinarAttendeeList : JSON.stringify(this.stuinfonew),
        userId : this.userId,
        videoPath: finalVideoPath,
        isLive: 0
};
console.log(obj);
this.ApiServiceCall.createWebinar(obj).subscribe((data) => {

  console.log(data.responseMessage);
  alert('success');
  
});
    }
  });
 isLive = '0';
}
else
{
  isLive = '1';
  this.selectedFile = '';
  var obj = {
    eventName : this.eventTitle,
    roomName: this.Room,
    startDateTime : this.startDateTime,
    endDateTime : this.endDateTime,
    note : '',
    takenBy : this.takenById,
    webinarAttendeeList : JSON.stringify(this.stuinfonew),
    userId : this.userId,
    videoPath: '',
    isLive: 1
};
console.log(obj);
this.ApiServiceCall.createWebinar(obj).subscribe((data) => {

console.log(data.responseMessage);
alert('success');

});
}

   
    
  }
  createEvent() {
this.startDateTime = this.startDate+ ' ' + this.startTime + ':00';
this.endDateTime = this.endDate + ' ' + this.endTime + ':00';
alert(this.startDateTime );
    if (this.isShownMeetingDetails == true) {


      if (this.isEmptyValue(this.eventTitle) || this.isEmptyValue(this.startDateTime) || this.isEmptyValue(this.endDateTime) || this.stuinfonew.length == 0) {
        alert('pls fill all fields');
      }
      else {

        this.Room = 'Meeting-' + this.makeid(6);
        this.createMeeting();
      }
    }
    else {

      if (this.isEmptyValue(this.eventTitle) || this.isEmptyValue(this.startDateTime) || this.isEmptyValue(this.endDateTime) || this.stuinfonew.length == 0 || this.isEmptyValue(this.takenById)) {
        alert('pls fill all fields');
      }
      else {
        this.Room = 'Webinar-' + this.makeid(6);
        
      this.createWebinar();
      }
    }

  }

  onEventTypeChange(value) {
    if (value == 'isMeeting') {
      this.isShownMeetingDetails = true;
    }
    else {
      this.isShownMeetingDetails = false;
    }
  }

  onWebinarTypeChange(value) {
    if (value == 'isRecorded') {
      this.isShownRecordedDetails = true;
    }
    else {
      this.isShownRecordedDetails = false;
    }
  }
  onFileSelected(event){
    this.selectedFile = event.target.files[0];

    }
  onModuleTypeChange(value) {
    if (value == 'isERP') {
      this.isShownERPDetails = true;
      this.isShownSMSDetails = false;
    }
    else if (value == 'isSMS') {
      this.isShownERPDetails = false;
      this.isShownSMSDetails = true;
    }
  }
  onUserTypeChange(value) {
    if (value == 'isGroup') {
      this.isShownGroupDetails = true;
      this.isShownModuleDetails = false;
    }
    else if (value == 'isOrganization') {
      this.isShownGroupDetails = false;
      this.isShownModuleDetails = true;
    }
  }


  makeid(length) {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  makepassword(length) {
    var result = '';
    var characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }



  isEmptyValue(value) {
    if (
      value === "0" ||
      value === "" ||
      value === 0 ||
      value === undefined ||
      value === null
    ) {
      return true;
    } else {
      return false;
    }
  }


}
